exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".short-dispatch-price-field[data-v-1afee3bc]{min-width:85px}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Modal-templates/ShortDispatch-modal.vue"],"names":[],"mappings":"AACA,6CACE,cAAgB,CACjB","file":"ShortDispatch-modal.vue","sourcesContent":["\n.short-dispatch-price-field[data-v-1afee3bc] {\n  min-width: 85px;\n}\n\n  /* @media only screen and (max-width: 800px) {\n    body {\n      display: flex;\n      flex-direction: column;\n      color: red;\n      background-color: red;\n    }\n  } */\n"],"sourceRoot":""}]);

// exports
